export default __webpack_public_path__ + "static/applying-grid-dark-186f5a9d2c7fd390b8f83de511602a81d02ed9dbc2a2ede8eed3f6e7fb75e638.png";